import type { TransitionTrigger } from "@spz/shared-domain";
import { Button } from "@spz/ui/components/button";
import type { IconSymbol } from "@spz/ui/components/icon";
import { useTranslation } from "react-i18next";

export interface WorkflowTransitionButtonProps {
  trigger: TransitionTrigger;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export function WorkflowTransitionButton({
  trigger,
  onClick,
  disabled = false,
  loading = false,
}: WorkflowTransitionButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      leftIcon={trigger.icon as IconSymbol}
      onClick={onClick}
      className="h-5.5"
      variant={trigger.variant}
      disabled={disabled}
      loading={loading}
    >
      {t(trigger.label_key)}
    </Button>
  );
}
